export default {
  请去APP端进行操作: 'Please go to the APP terminal for operation',
  最多填写20个数字: 'Character limit: 20 numbers.',
  最多填写15个数字: 'Character limit: 15 numbers.',
  最多填写20个汉字: 'Characters Limit: 40',
  最多填写30个汉字: 'Characters Limit: 60',
  最多填写30个汉字2: 'Characters Limit: 30',
  最多填写300个汉字: 'Characters Limit: 600',
  最多填写5000个汉字: 'Characters Limit: 10000',
  请输入企业简介: 'Please enter your Company Introduction',
  请输入企业名称: 'Please enter your Company Name',
  '请输入正确的固定电话,如：0341-86091234': 'Please enter the correct fixed phone number. Such as：0341-86091234',
  申请入驻请点击: 'Verify Now',
  待开幕: 'Upcoming',
  进行中: 'Underway',
  已结束: 'Ended',
  待开展: 'Upcoming',
  开展中: 'Underway',
  '参加展览、会议、展示企业信息、产品等~':
    'Participate in exhibitions and conferences to showcase your products and increase brand exposure.',
  '组织举办云上展览、线下展览、会议等等~': 'Organize virtual and offline trade shows and conferences.',
  '提供展厅模型下载、展厅搭建施工服务等~':
    'Provide construction services of showrooms, exhibition stands, exhibition halls, and etc.',
  '设计海报以及模型供用户下载使用,人性化设计服务,获得高额分成~':
    'Design and customize poster templates to earn a handsome profit.',
  添加产品成功: 'Product Added Successfully!',
  请选中产品后添加: 'Please select some product options before adding them to your exhibit list.',
  审核中: 'Under Review',
  审核拒绝: 'Rejected',
  待平台审核: 'Under Review',
  平台拒绝通过: 'Rejected',
  待主账号审核: 'Under Review',
  主账号拒绝通过: 'Rejected',
  '该内容已下架,无法操作': 'This content has been removed and therefore cannot be edited.',
  提前结束展览成功: 'You have successfully ended this event in advance.',
  查看详情: 'View Details',
  暂无可添加的产品: 'No available products yet.',
  添加企业展品: 'Add Exhibits',
  邀请海报: 'Poster',
  我要直播: 'Go Live Now',
  备注: 'Notes',
  完工时间: 'Completion Date',
  微信: 'WeChat',
  联系电话: 'Phone Number',
  名称: 'Name',
  报名信息: 'Registration Info',
  看直播: 'Watch Live Streams',
  展览地址: 'Venue Address',
  开幕时间: 'From',
  自动结束: 'To',
  主动结束: 'Ended Manually',
  抽审下架: 'Removed by the Platform',
  审核通过: 'Approved',
  待审核: 'Pending Review',
  发布展览: 'Post an Exhibition',
  发布中: 'Active',
  已驳回: 'Rejected',
  查看原因: 'View Reasons',
  知道了: 'OK',
  编辑类型: 'Type',
  提交时间: 'Submission Date',
  已通过: 'Approved',
  已拒绝: 'Rejected',
  企业名称关键词: 'Keywords',
  // 产品
  发布产品: 'Upload a Product',
  参展成功报名后提示语:
    'Notice: After successful sign-up, please upload your products at your earliest convenience. All products uploaded will be displayed as your exhibits at every exhibition you have joined.',
  审核成功: 'Approved Successfully',
  通过: 'Approve',
  驳回: 'Reject',
  驳回成功: 'Rejected Successfully',
  撤销成功: 'Undid Successfully',
  确定继续该撤销操作吗: 'Are you sure you want to undo this action?',
  撤销: 'Undo',
  拒绝原因: 'Reasons of Rejection',
  参展商审核通过提示:
    'Once approved, this company will be able to upload their products to your event as an exhibitor. Are you sure you want to approve this exhibitor request? ',
  申请时间: 'Submission Date',
  审核状态: 'Status',
  客户备注: 'Notes',
  产品标题: 'Product Name',
  请选择产品行业分类: 'Please Select Industry',
  确认下架该产品吗: 'Are you sure you want to remove this product?',
  置顶: 'Top',
  取消置顶: 'Cancel Top',
  下架: 'Remove',
  重新上架: 'Reactivate',
  新增: 'Add',
  平台抽审下架原因: 'Reasons of Removal:',
  产品封面: 'Cover Image',
  产品信息: 'Product Info',
  产品列表: 'All Products',
  确认删除当前规格吗: 'Are you sure you want to delete this product?',
  在线产品: 'Active',
  立即发布: 'Submit',
  // 基本资料
  个人信息: 'Personal Info',
  未添加手机号: 'No cellphone number added yet.',
  更换手机号: 'Change Cellphone Number',
  添加手机号: 'Add Cellphone Number',
  可用于登录云展动力各个终端平台: 'You can log in to our platform on all devices with your cellphone number.',
  更换邮箱: 'Change E-mail Address',
  添加邮箱: 'Add E-mail Address',
  登录密码: 'Password',
  我的邀请: 'My Invitation',
  我的邀请码: 'My Invitation Code',
  '可复制您的邀请码给亲友进行注册,获取更多权益':
    'Share your invitation code to invite new users and get more exclusive benefits!',
  企业行业属性: 'Industry You Are Involved in',
  感兴趣的行业: 'Industries You Are Interested in',
  '设置企业行业属性,获取更精准的数据营销推送':
    'Please select the industry your business is involved in so that we can provide you with more personalized service.',
  '设置感兴趣的行业,获取更多更精准的头条推荐':
    'Select the industries you are interested in to get more personalized news recommendations.',
  // 基本资料-个人身份
  真实姓名: 'Real Name',
  身份证号码: 'ID Number',
  自我介绍: 'Self-Introduction',
  // 基本资料-按钮
  更换: 'Change',
  修改: 'Edit',
  添加: 'Add',
  复制: 'Copy',
  // 基本资料-更换手机或邮箱弹框
  最多30个字符: 'Character Limit: 60.',
  修改用户名: 'Change Username',
  解除绑定: 'unbind',
  修改用户名成功: 'successfully modified',
  修改邮箱成功: 'successfully modified',
  '请输入用户名！': 'Please enter userName!',
  '用户名不可超过30个字符,15个汉字！': 'userName cannot exceed 30 characters',
  '密码长度为6-18位,建议字母、数字混合设置':
    'Your password must be 6-18 characters in length, and preferably contains both letters and numbers.',
  当前手机号: 'Current Cellphone Number',
  当前邮箱: 'Current E-mail Address',
  '为了您的账号安全,请先请输入当前手机号的验证码,验证是否为本人操作':
    'To verify your identity, please enter the verification code sent to your current cellphone number.',
  '为了您的账号安全,请先请输入当前邮箱的验证码,验证是否为本人操作':
    'verify your identity, please enter the verification code sent to your current E-mail address.',
  '请确保新增的手机号为全新未注册的11位纯数字手机号,且首位数字为1':
    'Please make sure the new cellphone number is unregistered, and the first digit is 1.',
  请确保添加的邮箱为全新未注册: 'Please make sure the new e-mail address is unregistered.',
  请输入当前手机号的验证码: 'Please enter the verification sent to your current cellphone number.',
  请输入当前邮箱的验证码: 'Please enter the verification code sent to your current E-mail address.',
  新手机号: 'New Cellphone Number',
  新邮箱: 'New E-mail Address',
  '请确保所更换的手机号为全新未注册的11位纯数字手机号,否则无法更换':
    'Please make sure the new cellphone number is unregistered.',
  请输入新手机号: 'Please Enter a New Phone Number.',
  请输入新邮箱: 'Please enter a new E-mail address.',
  新手机号验证码: 'Verification Code for New Cellphone Number',
  新邮箱验证码: 'Verification Code for New E-mail Address',
  请输入新手机号验证码: 'Please enter the verification code sent to your new cellphone number.',
  请输入新邮箱验证码: 'Please enter the verification code sent to your new E-mail address. ',
  未添加邮箱: 'No E-mail account added yet.',
  暂未绑定: 'Not Linked',
  // 基本资料-密码
  修改登录密码: 'Reset Password',
  原密码: 'Old Password',
  请输入原密码: 'Please enter the old password.',
  新密码: 'New Password',
  请输入新密码: 'Please enter a new password.',
  再次设置新密码: 'Repeat New Password',
  // 基本资料-修改头像
  修改头像: 'Edit Profile Picture',
  更换头像: 'Change Profile Picture',
  重新选择: 'Re-select',
  个人头像上传提示: 'JPG/PNG formats are accepted. Image resolution: 200*200. Maximum file size: 5M.',
  // 基本资料-修改企业行业属性
  选择您所属行业: 'Please select your industry.',
  选择感兴趣的行业: 'Choose an industry of interest',
  请选择您感兴趣的行业: 'Please select the industry you are interested in',
  '为了更好提供精准的数据服务,请选择您感兴趣的行业':
    'In order to better provide accurate data services, please select the industry you are interested in',
  '为了更好提供精准的数据服务,请选择您所属的行业':
    'For us to provide you with better service, please select your industry.',
  选择您感兴趣的行业: 'Select the industry you are interested in',
  '为了更好提供精准的数据服务, 请选择您感兴趣的行业':
    'In order to provide you with better data services, please select the industry you are interested in',
  '确定,下一步': 'Next',
  请选择您所属的行业: 'Please select your industry.',
  最多可选择5个行业: 'You can select 5 industries at most.',
  请至少选择一个所属行业: 'Please select at least one industry.',
  '您发布的内容《标题》正在审核中,平台预计2-3个工作日完成审核,审核结果会以站内信通知,请耐心等待！':
    'Your submission will be processed within 2-3 working days. Remember to check your Message Center for your review result.',
  '请填写赞助商名称,审核通过之后,该赞助商名称即显示在您发布的会议详情中':
    'Please enter the name of the sponsor. Once approved, this sponsor will be displayed on the detail page of your event.',
  请输入赞助商名称: 'Please enter the sponsor’s name',
  '请确认是否驳回该赞助商？': 'Are you sure you want to reject this sponsorship request?',
  // 招标管理
  发布招标: 'Publish a Tender',
  // 我的钱包
  '因目前相关政策限制,充值成功后,充值资金仅限于购买本站付费服务或购买本站提供的第三方付费服务,不支持任何形式与理由提现或者退款,敬请知悉！':
    'Cloud Exhibition Coin is a virtual currency used by our users to purchase service provided by this website or a third party. Once bought, it is nonrefundable and can’t be withdrawn.',
  '金币充值1元起充,1元=1金币(可用于会员充值、海报购买、模型购买等);':
    'The minimum top-up is one yuan (one coin for one yuan). The coins can be used to purchase poster templates, booth designs, and etc.',
  '充值金额不可提现,仅收入金额可提现,提现申请将于15个工作日内完成审核,节假日顺延':
    'Top-up monies cannot be withdrawn in cash, and only income is withdrawable.  Withdrawals arrive within 15 working days.',
  总金额: 'Account Balance',
  充值金额: 'Top-up Amount',
  收入金额: 'Income',
  提现中收入金额: 'Withdrawals Being Process',
  普通收入: 'ordinary income',
  活动收入: 'activity income',
  交易明细: 'Transaction Details',
  消费: 'Purchase',
  收入: 'Income',
  提现: 'Withdrawal',
  提现详情: 'Details',
  提现编号: 'No.',
  提现时间: 'Date',
  申请提现金额: 'Withdrawal Amount',
  手续费率: 'Handling Fee Rate',
  手续费: 'Handling Fee',
  预估到账金额: 'Estimated Net Withdrawal',
  提现终端: 'Withdrew on',
  提现中: 'Being Processed',
  提现成功: '提现成功',
  提现失败: '提现失败',
  提现信息: 'Withdrawal Info',
  提现到支付宝账号: 'Withdraw to Alipay Account',
  支付宝账号的收款人姓名: 'Payee’s Name',
  转账信息: 'Transfer Info',
  出款支付宝账户: 'Withdrawal to Alipay Account',
  银行: 'Bank Name',
  支付宝账户银行卡转账: 'Alipay to Bank Card',
  支付宝余额转账: 'Alipay Balance Transfer',
  出款方式: 'Payment Method',
  实际提现到账金额: 'Net Withdrawal',
  操作时间: 'Date',
  交易状态: 'Status',
  订单号: 'Purchase No',
  订单详情: 'order details',
  下单时间: 'Submission Date',
  实际交易金额: 'Actual Transaction Amount',
  商户订单号: 'Supplier/Provider Order No',
  财务类型: 'Income Type',
  交易时间: 'Transaction Date',
  '收支金额(金币)': 'Income & Expenditure (Coins)',
  充值编号: 'Top-up No',
  充值方式: 'Top-up Method ',
  当前账户余额: 'Current Account Balance',
  // 消息中心
  通知: 'Message',
  暂无通知: 'No Message',
  暂无洽谈: 'No Chat',
  站内信: 'Notification',
  站内信为空: 'No Notification',
  // 洽谈框
  暂无对方基本信息: 'He/she doesn’t have a personal profile yet',
  '聊天记录支持多端同步,并最多保存最近90天聊天记录':
    'Your chat history will be synced on multiple devices, and stored for 90 days',
  表情: 'Emoji',
  图片: 'Picture',
  视频: 'Video',
  音频: 'Audio',
  音频下载失败: 'Audio download failed',
  文件: 'File',
  聊天记录: 'Chat History',
  挂断: 'Hang up',
  接通: 'Answer',
  '未检测到摄像头、麦克风,请检查设备或转移手机 App继续视频':
    'The camera and microphone are not detected, please check the device or transfer to the mobile  app to continue the video',
  '未检测到摄像头、麦克风,请检查设备或转移手机 App继续音频':
    'The camera and microphone are not detected, please check the device or transfer to the mobile  app to continue the audio',
  等待对方接受邀请: 'Waiting for the other party to accept the invitation',
  邀请您语音通话: 'Invites you to a voice call',
  邀请您视频通话: 'Invites you to a video call',
  对方已取消视频聊天: 'The user you have contacted has cancelled the video chat',
  对方已取消语音聊天: 'The user you have contacted has cancelled the voice chat',
  已取消视频聊天: 'You have cancelled the video chat',
  已取消语音聊天: 'You have cancelled the voice chat',
  视频聊天: 'Video chat duration',
  语音聊天: 'Voice chat duration',
  您有未接语音聊天请求: 'You have a missed voice chat request',
  您有未接视频聊天请求: 'You have a missed video chat request',
  对方未接通: 'Unconnected',
  '对方在忙！请稍后再拨打！': 'The user you have contacted is busy now, please call again later',
  已拒绝语音聊天: 'The user you have contacted has refused voice chat',
  已拒绝视频聊天: 'The user you have contacted has refused video chat',
  对方拒绝您的语音聊天请求: 'The user you contacted rejects your voice chat request',
  对方拒绝您的视频聊天请求: 'The user you contacted rejects your video chat request',
  '对方未上线,发起语音聊天失败': 'The user you have contacted is not online, failed to initiate voice chat',
  '对方未上线,发起视频聊天失败': 'The user you have contacted is not online, failed to initiate video chat',
  '对方在忙,请稍后再拨打': 'The user you have contacted is busy now, please try again later',
  对方已挂断: 'The user you contacted has left the chat',
  '对方或己方网络质量不佳,请及时处理': 'Poor network quality, please deal with it promptly',
  对方拒绝通话: 'The user you contacted refused the call',
  '网络连接超时,已断开': 'Network connection timeout, disconnected',
  '对方不在线,请稍后重试': 'The user you contacted is not online, please try again later',
  '对方未接通,请稍后重试': 'The user you contacted is not connected, please try again later',
  // 其他
  岗位不能为空: 'Please fill out this field.',
  报名日期: 'Application Date',
  备注内容: 'Notes',
  进入会员中心: 'Enter User Center',
  回到首页: 'Return to Homepage',
  前往主页: 'Go to Homepage',
  标题: 'Title',
  发布用户: 'Publisher',
  下午好: ' Good Afternoon',
  上午好: 'Good Morning!',
  收藏数: 'Total Saves',
  '提示：滚动鼠标中间键,可以缩放图片大小': 'Tip: scroll the middle mouse button to zoom the size of the picture;',
  // 其他
  '抱歉,没有找到筛选的相关现场直播': 'Sorry. No matching result found.',
  '抱歉,没有找到筛选的相关企业展品': 'Sorry. No matching result found.',
  '抱歉,没有找到筛选的相关企业3D': 'Sorry. No matching result found.',
  // 当前内容,非原创,转载于（渠道）
  '非原创,转载于': 'Origin',
  开播: 'Start',
  下架产品: 'Remove Product',
  采购单号: 'Order No',
  招标标题: 'Tender Title',
  招标列表: 'All Tenders',
  请选择招标类型: 'Please select category',
  请选择招标地区: 'Please select location',
  招标行业分类: 'Industry Classification',
  请选择招标行业分类: 'Please select industry',
  在线招标: 'Active Tender',
  浏览招标详情: 'View Tender Details',
  请输入招标标题: 'Please enter tender title',
  招标内容: 'Content',
  请输入招标详细内容: 'Please enter your content',
  立刻发布: 'Publish Now',
  展品分类: 'Exhibit Category',
  请选择展品类型: 'Please select category',
  展品标题: 'Exhibition Title',
  订单类型: 'type',
  '电子普通发票和纸质普通发票具备同等法律效力,可支持报销入账,平台在订单完成后1-3个工作日内开具,请留意您的邮箱':
    'Electronic invoices and paper invoices have the same legal effects, and can both be used in reimbursement and bookkeeping. Your invoice will be issued within 1 to 3 working days after each successful purchase. Remember to check your inbox.',
  '已开票,请留意您发票接收邮箱': 'Invoice has been issued. Remember to check your inbox.',
  模型编号: 'Design No',
  海报编号: 'Poster No',
  立即观看: 'Watch Now',
  申请发票: 'Request Invoice',
  订单编号: 'Purchase No',
  海报设计: 'Poster Template',
  会员服务: 'User Service',
  交易金额: 'Transaction Amount',
  商家信息: 'Supplier/Provider Info',
  商家: 'Supplier/Provider',
  发票信息: 'Invoice Info',
  发票类型: 'Type',
  发票内容: 'Content',
  发票抬头: 'Invoice Letterhead',
  个人名称: 'Full Name',
  单位名称: 'Company Name',
  纳税识别码: 'Taxpayer Identification Code',
  收票人邮箱: 'E-mail Address',
  收票人手机: 'Cellphone Number',
  开票中: 'Being  Processed',
  已出票: 'Issued',
  转载备注: 'Notes',
  // 我的直播
  播放: 'Play',
  创建直播: 'Start a live Stream',
  继续直播: 'Continue',
  我的回放: 'Replay',
  重新直播: 'Restart',
  直播信息: 'Live Stream Info',
  直播时间: 'Start Time',
  添加展品: 'Add Exhibit',
  直播已结束: 'Live Stream Ended',
  实际开播时间: 'Actual Start Time',
  实际结束时间: 'Actual End Time',
  直播时长: 'Duration',
  累计观看人数: 'Total Viewers',
  采购单数: 'Number of Orders',
  累计成交金额: 'Cumulative Transaction Amount',
  直播已禁播: 'Live Stream Banned ',
  当前在线人数: 'Current Viewers',
  '累计观看（人次）': 'Total Views',
  直播数据: 'Live Stream Data',
  请选择要添加的产品: 'Please select products.',
  直播回放信息: 'Replay Info',
  请选择子账号类型: 'Select a type of account.',
  // 展览管理-发布展览
  '没有权限发布展览,请联系客服': 'No permission to post exhibitions. Please contact customer service',
  '展览类型错误,请联系客服': 'Exhibition type error. Please contact customer service',
  发布新展览: 'Post Exhibition',
  '我已阅读以上须知,确定创建该类展览': 'I have read the notice above and I want to create this type of exhibitions',
  展览信息: 'Event Info',
  展览属性: 'Event Attributes',
  展览标题: 'Event Title',
  请输入展览标题: 'Please enter event title',
  点击上传图片: 'Click Her to Upload Photos',
  展览主图: 'Cover Image',
  '图片格式为JPG/PNG,分辨率540*300,大小不能超过2M':
    'JPG/PNG formats are accepted. Image resolution: 540*300. Maximum file size: 2M',
  展览时间: 'Event Date',
  结束时间: 'End Date',
  请输入届次: 'Please enter edition',
  纯数字: 'Numbers only ',
  参展联络: 'Contact Info',
  '中国（+86）': 'China (+86)',
  请输入固定电话: 'Please enter a fixed phone number',
  联系微信: 'WeChat',
  请输入微信: 'Please enter WeChat account',
  请输入公司官网地址: "Please enter company's official website address",
  '请输入主办单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    'You can enter up to 20 hosts. Each name will occupy one row and contain less than 400 characters.',
  '请输入支持单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    'You can enter up to 20 hosts. Each name will occupy one row and contain less than 400 characters.',
  '请输入承办单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    'You can enter up to 20 hosts. Each name will occupy one row and contain less than 400 characters.',
  '请输入协办单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    'You can enter up to 20 hosts. Each name will occupy one row and contain less than 400 characters.',
  基本信息: 'Basic info',
  '3D超链接': 'Hyperlink to 3D Display',
  '若有3D展示,则输入展览3D超链接': 'Please enter hyperlink. (Optional)',
  请输入展览简介: 'Please enter event introduction',
  请输入展览范围: 'Please enter exhibition scope',
  提示: 'Notice',
  展览类型: 'Exhibition Type',
  请选择展览类型: 'Please select the exhibition type',
  最多输20行: 'Within 20 lines',
  每行200个字符内: 'Within 200 characters each line',
  请至少增加一个自定义标签: 'Please add at least one tag',
  请填写展览费用中标准展位的国内企业费用: 'Please enter the standard booth rate for domestic exhibitors',
  请填写展览费用中标准展位的境外企业费用: 'Please enter the standard booth rate for overseas exhibitors',
  请填写展览费用中标准展位的展位物品清单: 'Please enter list of standard booth fittings and fixtures.',
  请填写展馆信息中的展馆名称: 'Please enter name of the venue',
  请填写展馆信息中的展馆详细地址: 'Please enter detailed venue address',
  请上传展馆信息中的展馆图片: 'Please upload pictures of the venue',
  '提交展览信息成功,请等待审核': 'Submission successful. Please wait patiently for review result.',
  '请上传 480*270 尺寸以上图片,当前图片': 'Minimum resolution: 480*270. Current resolution',
  标签只可以输出三十个字以内: '30 characters at most for each tag',
  自定义标签最多10个: '10 tags at most',
  '请上传 1920*430 固定尺寸图片,当前图片': 'Required resolution: 1920*430. Current resolution',
  '请上传 540*300 尺寸以上图片,当前图片': 'Minimum resolution: 540*300. Current resolution',
  '请勿上传涉黄、广告、反动、政治性等违禁照片,否则按照平台相关规定处理,严重者上报监管部门':
    'Please do not upload images containing contents like pornography, advertisements, political issues, and etc. All violations will be handled in accordance with the relevant regulations of the platform. Severe violators will be reported to related authorities.',
  暂无上传的照片: 'No photos yet.',
  单击或将文件拖到该区域以上传: 'Drag and drop or click here',
  '支持单次或批量上传。 单张图片限 5MB 以内,格式：JPG/JPEG/PNG':
    'You can upload one single photo or multiple photos at a time. Supported formats: JPG/JPEG/PNG. Maximum file size: 5M',
  图片上传成功: 'Upload Successful',
  图片上传失败: 'Upload Unsuccessful',
  '图片路径为空,关联展览失败': 'Image path is empty. Failed to link exhibition',
  // 《违反原因》 驳回原因
  '您发布的内容违反了《违反原因》,请修改再重新发布！': '您发布的内容违反了《违反原因》,请修改再重新发布！',
  企业认证申请·主办商: 'Event Organizer Verification Application',
  企业认证申请·工程商: 'Contractor Verification Application',
  企业认证申请·设计师: 'Designer Verification Application',
  企业认证申请·参展商: 'Exhibitor Verification Application',
  展厅搭建申请: 'Booth Construction',
  裁剪: 'Tailor',
  // 会议管理
  历史会议: 'History Meeting',
  发布会议: 'Post Meeting',
  图形验证码: 'Graphic verification code',
  请输入图片中的验证码: 'Please input the verification code in the picture',
  发布新会议: 'Post New Conference',
  '我已阅读以上须知,确定创建该类会议': 'I have read the notice above and I want to create this type of conferences',
  会议信息: 'Conference Info',
  会议属性: 'Category',
  会议标题: 'Conference Name',
  请输入会议标题: 'Please enter Conference Name',
  会议主图: 'Cover Image',
  参会联络: 'Organizer Contact Info',
  请输入会议简介: 'Please enter event introduction.',
  会议嘉宾: 'Special Guests/Speakers',
  请输入会议嘉宾: 'Please enter names of special guests/speakers',
  请输入会议日程: 'Please enter event agenda',
  会场名称: 'Venue Name',
  请输入会场标题: 'Please enter Venue Title',
  会场图片: 'Venue Photo',
  '图片格式为JPG/PNG,大小不能超过2M': 'JPG/PNG formats are accepted. Maximum file size: 2M',
  请输入会议门票: 'Please enter the details of registration fees',
  '会议简介、会议嘉宾、会议日程、会场信息、会议门票不允许出现任何联系方式、反动、暴力以及色情等相关内容':
    'Please don not include or show your contact info, or any illegal, inappropriate, violent, or pornographic contents in event introduction, special guests/speakers, ',
  '若需要请在【参会联络】进行完善,否则审批不通过！':
    'event agenda, venue info, and registration fees, or your submission will be rejected.',
  请上传会议主图: 'Please upload a cover image',
  会议时间不能为空: 'Date/Time cannot be empty',
  请输入会议面积: 'Please enter Total Area',
  请输入举办年数: 'Please enter the number of years',
  请输入举办次数: 'Please enter the number of editions',
  请输入导读简介: 'Please enter the lead paragraph',
  '提交会议信息成功,请等待审核': 'Submission successful. Please wait for your review result patiently',
  // 资讯
  发布头条: 'Post Industry News',
  发布新头条: 'Post Industry News',
  线上头条: 'Active',
  历史头条: 'Removed',
  头条详情: 'News Detail',
  下架头条成功: 'Removal Successful',
  请输入头条标题: 'Please enter Title',
  最多填写65个汉字: 'Character Limit: 130',
  请上传头条主图: 'Please upload Cover Image',
  请输入头条详细内容: 'Please enter the information details',
  请选择头条来源: 'Please select the source',
  '请填写转载来源,最多填写20个汉字': 'Please enter Original Poster',
  请输入原创姓名: 'Please enter the original name',
  请认真阅读后同意协议: 'I agree to the following terms and policies',
  头条分类: 'category',
  头条行业分类: 'industry',
  请选择头条行业分类: 'Please select an industry',
  '我已阅读以上须知,确定创建该类头条': 'I have read the notice above and I want to create this type of exhibitions',
  头条信息: 'Information',
  头条属性: 'Category',
  头条标题: 'Title',
  头条主图: 'Cover Image',
  点击上传主图: 'Click Her to Upload Cover Image',
  头条来源: 'Source',
  原创: 'Original',
  转载: 'Reprint',
  请输入姓名: 'Please enter your name',
  头条内容: 'information content',
  '招标标题不能为空！': 'Title cannot be empty',
  '招标正文不能为空！': 'Content cannot be empty',
  请选择或输入搜索招标地区: 'Please select or enter a location',
  '账单生成,每月10号系统会自动生成上月业务账单,选择账单即可申请开具电子普通发票；':
    '1. Your bill for the previous month will be sent to your account on the 10th of each month. You can request for an electronic invoice by selecting the corresponding  bill；',
  '账单过期,账单生成后3个月内有效,以生成账单日期起,3个月后的账单将无法开票。例：202005的账单,于2020-06-10生成,则将于2020-9-31后过期,无法开票。':
    'Once issued, your bill will expire in three months. Please request for your invoice before expiration. Example: A bill for the May of 2020, issued on 2020-06-10, can no longer be invoiced after 2020-9-31',
  '发票接收,发票已出票后,请查看您在申请开票所所填写的邮箱。':
    'Your invoice will be sent to the E-mail address you submit in your invoice request. Please don’t forget to check you mailbox.',
  月份: 'Month',
  金额: 'Amount',
  发票金额: 'Invoice Amount',
  发票月份: 'Month',
  发票详情: 'Details',
  开票状态: 'Status',
  '加载中...': 'loading...',
  技术服务费: 'Technical Service Fee',
  会员服务费: 'User Service Fee',
  电子普通发票: 'Electronic Receipt',
  '金币充值1元起充,1元=1金币（可用于会员充值、海报购买、模型购买等）；':
    'Minimum top-up: 1 yuan per coin. Coins can be used to purchase poster templates, booth designs, and etc；',
  '因目前相关政策限制,充值成功后,充值资金仅限于购买本站付费服务或购买本站提供的第三方付费服务,不支持任何形式与理由进行提现或者申请退款,敬请知悉！':
    'Cloud Exhibition Coin is a virtual currency used by our users to purchase service provided by this website or a third party. Once bought, it is nonrefundable and can’t be withdrawn',
  选择支付类型: 'Select Payment Method',
  请输入充值金额: 'Please enter your top-up amount.',
  实际到账金额: 'Net Withdrawal',
  确定充值: 'Confirm and Top-up',
  充值记录: 'Top-up History',
  云展动力收银台: 'Checkout',
  应付金额: 'Payment Amount',
  微信扫码支付: 'WeChat QR Code Payment',
  我已支付: 'Paid Already',
  充值成功: 'Top-up Successful',
  充值失败: 'Top-up Unsuccessful',
  '很抱歉,金额过高,请再次检查是否填写有误': 'Sorry, your top-up amount is too high. Please check and try again',
  请输入金额: 'Please enter an amount',
  '最低提现金额为xx元起,提现手续费xx%': '最低提现金额为xx元起,提现手续费xx%',
  '提现到账时间为1-5个工作日,节假日顺延': 'Your withdrawal will arrive within 1-5 working days',
  '提现申请成功,请等待后台审核': 'Your withdrawal will arrive within 1-5 working days.',
  请点击发送验证码: 'please click “Send Verification Code”',
  点击发送验证码: 'Send Verification Code',
  请输入提现金额: 'Please enter withdrawal amount.',
  请输入支付宝账号: 'Please enter your Alipay account',
  请输入支付宝收款人姓名: 'Please enter the the payee’s name registered with Alipay.',
  请输入收款人名称: 'Please enter payee’s name',
  提现金额: 'withdrawal amount.',
  支付宝账号: 'Alipay Account',
  '请输入支付宝账户/手机号码': 'Please enter your Alipay account/phone number.',
  提交申请: 'Submit',
  提现记录: 'Withdrawal History',
  提现信息确认: 'Withdrawal Info confirm',
  收款人姓名: ' payee’s name.',
  请输入短信验证码: 'Please enter verification code!',
  立即提现: 'Withdraw Now',
  首位绑定子账号: 'First Contact Person',
  当前绑定的子账号: 'Current Contact Person',
  '确定要解绑吗？解绑成功后,该客户之后所产生所有的数据都不归当前子账号所属':
    'Are you sure you want to unlink? Once unlinked, all data generated later by this customer will not longer belong to this employee account',
  绑定成功: 'Linked Successfully',
  解绑成功: 'Unlinked Successfully',
  子账号详情: 'Account Details',
  操作成功: 'Action Successful',
  重置成功: 'Reset Successful',
  绑定时间: 'Linked on',
  指派时间: 'Linked on',
  重置密码: 'Reset Password',
  启用: 'Enable',
  重置登录密码: 'Reset Login Password',
  客户绑定列表: 'All Linked Customers',
  客户公司: 'Company',
  '确定要解绑吗？': 'Are you sure you want to unlink?',
  解绑: 'Unlink ',
  展馆名称: 'Pavilion Name',
  请输入展馆名称: 'Please enter Pavilion Name',
  展馆面积: 'Pavilion Area',
  展馆图片: 'Pavilion Drawing',
  示例图: 'Typical drawing',
  空地展位: 'Booth space',
  自定义: 'Custom',
  '注意：若国内企业/境外企业的展位价格输入为0元（或美元）,客户看到的则显示为【面议】,例如：国内企业（RMB）：面议':
    'If you set your booth rate at 0 yuan/dollar, the corresponding field will read “Price Negotiable”. For example, Domestic Exhibitor (RMB): Price Negotiable.',
  平方米: 'square metres',
  请输入豪华标准展位所提供的物品: 'Please enter Luxurious standard booth fixtures and fittings',
  请输入基本标准展位所提供的物品: 'Please enter standard booth fixtures and fittings.',
  请输入空地展位所提供的物品: 'Please enter Open space booth fixtures and fittings',
  请输入面积: 'Please enter the area',
  请上传展览云图: '请上传展览云图',
  请上传展览主图: '请上传展览云图',
  请输入展览面积: '请输入展览面积',
  展览时间不能为空: '展览时间不能为空',
  手机国际号: 'Phone Area',
  请选择手机国际地区: 'Select the Phone Area',
  更换定位: 'Change Location',
  更换地区: 'Change Region',
  热门城市: 'Hot City',
  国内热门城市: 'Popular Cities in China',
  清除所选项: 'Clear Selected',
  收起筛选: 'Hide Filters',
  展开筛选: 'Show Filters',
  '平均时长：分钟/次': 'Average Duration: Min(s)/Time',
  'raido-中文': '简体中文(Simplified Chinese)',
  'raido-英文': 'English',
}
